import { ApolloClient, createNetworkInterface } from "react-apollo";
import { SubscriptionClient, addGraphQLSubscriptions } from "subscriptions-transport-ws";
import { IntrospectionFragmentMatcher } from "react-apollo";

// export const SERVER = "localhost";
// const SERVER = '10.10.10.61'
export const SERVER = "vending.af7.es";

const myFragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: "INTERFACE",
          name: "type",
          possibleTypes: [{ name: "TEXTFIELD" }, { name: "SELECT" }],
        },
      ],
    },
  },
});

const networkInterface = createNetworkInterface({ uri: `https://${SERVER}/graphql` });
networkInterface.use([
  {
    applyMiddleware: (req, next) => {
      setTimeout(next, 500);
    },
  },
]);

const wsClient = new SubscriptionClient(`wss://${SERVER}/subscriptions`, { reconnect: true });
const networkInterfaceWithSubscriptions = addGraphQLSubscriptions(networkInterface, wsClient);

export const apolloClient = new ApolloClient({
  networkInterface: networkInterfaceWithSubscriptions,
  reduxRootSelector: (state) => state.get("apollo"), //This is needed to work with immutable.js
  fragmentMatcher: myFragmentMatcher,
  // dataIdFromObject: o => {
  //   if (o.__typename === 'Field') return `${o.__typename}-${o.name}`
  //   if (o.__typename === 'TextField') return `${o.__typename}-${o.name}`
  //   if (o.__typename === 'SelectField') return `${o.__typename}-${o.name}`
  //   return `${o.__typename}-${o.id}`
  // }
});



// WEBPACK FOOTER //
// ./src/redux/apolloClient.js